module.exports = "/virtual-football-league/img/amblems/right/Italy/Fake_Inter.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Italy/Fake_Inter.png
// module id = 2143
// module chunks = 4